import React from 'react';

import { Row, Col } from 'reactstrap';

const NotFoundPage = () => {
	return (
		<div className="error-page">
			<Row>
				<Col lg="12" className="mt-2 mb-2">
					<div className="ball">
						<i className="fticon-close"></i>
					</div>
					<h2>404</h2>
					<h4>Página no encontrada</h4>
				</Col>
			</Row>
		</div>
	);
};

export default NotFoundPage;
